import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/lib/content";
import { scrollToId } from "@/lib/site";
import { SectionHead, Reveal } from "@/components/Kinetic";
import { SERVICE_ILLOS } from "@/components/illustrations/ServiceIllos";

const Card = ({ s, i }) => {
  const Illo = SERVICE_ILLOS[s.id];
  return (
    <Reveal delay={0.08 * i} className="h-full">
      <article
        data-testid={`service-card-${s.id}`}
        className="svc-card group flex h-full flex-col rounded-[28px] bg-white p-3 transition-[transform,box-shadow] duration-500 hover:-translate-y-1.5 hover:shadow-[0_30px_60px_-30px_rgba(0,0,0,0.55)]"
      >
        <div className="relative rounded-[20px] bg-soft px-4 pt-4 transition-colors duration-500 group-hover:bg-emerald-mint">
          <span className="absolute left-5 top-5 font-mono text-[11px] text-muted">0{i + 1}</span>
          <div className="mx-auto max-w-[260px] pt-4">
            <Illo />
          </div>
        </div>
        <div className="flex flex-1 flex-col px-4 pb-4 pt-6">
          <h3 className="display text-[22px] leading-tight text-ink">{s.title}</h3>
          <p className="mt-3 flex-1 text-[15px] leading-relaxed text-muted">{s.desc}</p>
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); scrollToId("contact"); }}
            data-testid={`service-enquire-btn-${s.id}`}
            className="mt-7 inline-flex min-h-[48px] items-center justify-between rounded-full border border-line py-2 pl-5 pr-2 font-display text-[12px] font-bold uppercase tracking-[0.1em] text-ink transition-colors duration-300 hover:border-emerald hover:bg-emerald hover:text-white"
          >
            Start a project
            <span className="grid h-8 w-8 place-items-center rounded-full bg-emerald text-white transition-transform duration-300 group-hover:rotate-45">
              <ArrowUpRight className="h-4 w-4" />
            </span>
          </a>
        </div>
      </article>
    </Reveal>
  );
};

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="relative overflow-hidden bg-emerald-deep py-24 lg:py-36">
      <div aria-hidden="true" className="pointer-events-none absolute -right-32 -top-32 h-96 w-96 rounded-full border-[32px] border-white/[0.05]" />
      <div className="wrap relative">
        <SectionHead eyebrow="SERVICES" title="WHAT I DESIGN AND BUILD." hl={[3]} hlClass="hl-light" dark />
        <div className="mt-14 grid gap-5 sm:grid-cols-2 xl:grid-cols-4">
          {SERVICES.map((s, i) => (
            <Card key={s.id} s={s} i={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
